import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../components/site/Reveal";

const aboutImg =
  "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/5sgo3oqt_DSC09992_emergent%20%282%29.jpg";
const secondaryImg =
  "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/puyy0cfs_DSC09798_emergent.jpg";

const values = [
  {
    n: "01",
    title: "Detail as discipline",
    body:
      "Every detail is worked through before construction begins, creating a more thought out streamlined process.",
  },
  {
    n: "02",
    title: "Trades we've grown with",
    body:
      "We've built lasting relationships with our trades over the years — continuity that helps keep quality consistent.",
  },
  {
    n: "03",
    title: "Programs held, budgets protected",
    body:
      "A streamlined project management approach means our clients consistently experience builds that run on time and on budget.",
  },
  {
    n: "04",
    title: "Approachable, collaborative",
    body:
      "Collaborative, credible, professional, and always approachable. The best builds are the ones where architects, clients and builders talk openly.",
  },
];

export default function AboutPage() {
  return (
    <div data-testid="about-page" className="bg-zinc-950">
      <section className="pt-32 pb-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <div className="text-[11px] tracking-[0.3em] uppercase text-zinc-500">
              — About Tidemark
            </div>
            <h1 className="mt-6 font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tighter text-zinc-100 leading-[1.02] max-w-5xl">
              A quieter kind of{" "}
              <span className="italic text-zinc-300">builder.</span>
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="pb-24 sm:pb-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
          <div className="md:col-span-7">
            <Reveal>
              <img
                src={aboutImg}
                alt="Tidemark craft"
                className="w-full h-[70vh] md:h-[80vh] object-cover"
              />
            </Reveal>
          </div>
          <div className="md:col-span-5 md:pt-24">
            <Reveal delay={0.15}>
              <p className="font-serif text-2xl sm:text-3xl leading-[1.25] tracking-tight text-zinc-100">
                Tidemark Building Company is a high-end architectural builder
                based in Melbourne, specialising in custom, detail-driven
                homes and additions.
              </p>
              <p className="mt-8 text-zinc-400 text-lg leading-relaxed">
                We work with both architects and direct clients — guiding
                them through the full process, from planning right through to
                build completion.
              </p>
              <p className="mt-5 text-zinc-400 text-lg leading-relaxed">
                What sets us apart is meticulous attention to detail, the
                quality of our trades, and a genuinely streamlined approach
                to project management. An approach that consistently delivers
                builds on time and on budget.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="py-24 sm:py-32 border-t border-zinc-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <div className="text-[11px] tracking-[0.3em] uppercase text-zinc-500">
              — Principles
            </div>
            <h2 className="mt-4 font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-zinc-100 max-w-3xl">
              How we think about a build.
            </h2>
          </Reveal>
          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-px bg-zinc-900">
            {values.map((v, i) => (
              <Reveal key={v.n} delay={i * 0.08}>
                <div className="bg-zinc-950 p-10 md:p-14 h-full">
                  <div className="text-[11px] tracking-[0.3em] uppercase text-zinc-500">
                    {v.n}
                  </div>
                  <h3 className="mt-4 font-serif text-2xl sm:text-3xl text-zinc-100 tracking-tight">
                    {v.title}
                  </h3>
                  <p className="mt-4 text-zinc-400 leading-relaxed">
                    {v.body}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 sm:py-32 border-t border-zinc-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
          <div className="md:col-span-6">
            <Reveal>
              <img
                src={secondaryImg}
                alt="Material craft"
                className="w-full h-[70vh] object-cover"
              />
            </Reveal>
          </div>
          <div className="md:col-span-6">
            <Reveal delay={0.15}>
              <div className="text-[11px] tracking-[0.3em] uppercase text-zinc-500">
                — Who we work with
              </div>
              <h2 className="mt-4 font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tighter text-zinc-100 leading-[1.05]">
                Architects, direct clients, developers who care about the
                finish.
              </h2>
              <p className="mt-6 text-zinc-400 leading-relaxed">
                We chair the build with the same rigour whether the project
                originates with an architect, a private client, or a
                developer. The through-line is a shared standard.
              </p>
              <Link
                to="/contact"
                data-testid="about-cta-contact"
                className="inline-flex items-center gap-2 mt-10 text-[12px] tracking-[0.25em] uppercase text-zinc-100 border-b border-zinc-500 pb-1 hover:border-zinc-100"
              >
                Start a Conversation
                <ArrowUpRight size={14} strokeWidth={1.5} />
              </Link>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
